const pre = '/basic/';

export default {
    path: '/basic',
    title: '系统管理',
    header: '',
    icon: 'ios-construct-outline',
    children: [
        {
            path: `${pre}account`,
            title: '用户管理'
        },
        {
            path: `${pre}authority`,
            title: '角色管理'
        },
        {
            path: `${pre}menu`,
            title: '菜单管理'
        },
    ]
}
